
import React, { useEffect, useRef, useState } from "react";
import flagAL from "../assets/flags/al.svg";
import flagDE from "../assets/flags/de.svg";

const languageMap = {
  sq: { code: "SQ", label: "Shqip", flag: flagAL },
  de: { code: "DE", label: "Deutsch", flag: flagDE },
};

export default function LanguageSwitcher({ lang = "de", setLang }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const current = languageMap[lang] || languageMap.de;
  const items = Object.entries(languageMap);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-2.5 py-2 shadow-sm transition hover:bg-slate-50 md:px-3"
      >
        <img
          src={current.flag}
          alt={current.label}
          className="h-5 w-7 rounded-sm object-cover shadow-sm ring-1 ring-slate-200"
        />
        <span className="hidden text-sm font-semibold text-slate-700 sm:block">
          {current.label}
        </span>
        <span className="text-xs font-bold text-slate-400">{current.code}</span>
      </button>

      {open && (
        <div className="absolute right-0 mt-3 w-44 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
          <div className="border-b border-slate-100 px-4 py-3">
            <p className="text-xs uppercase tracking-[0.2em] text-slate-400">Language</p>
          </div>

          <div className="p-2">
            {items.map(([key, item]) => (
              <button
                key={key}
                type="button"
                onClick={() => {
                  setLang(key);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition ${
                  lang === key
                    ? "bg-slate-900 text-white"
                    : "text-slate-700 hover:bg-slate-50"
                }`}
              >
                <img
                  src={item.flag}
                  alt={item.label}
                  className={`h-5 w-7 rounded-sm object-cover shadow-sm ${
                    lang === key ? "ring-1 ring-white/30" : "ring-1 ring-slate-200"
                  }`}
                />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold">{item.label}</div>
                </div>
                <div className={`text-[11px] font-bold ${lang === key ? "text-white/70" : "text-slate-400"}`}>
                  {item.code}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
